<template>
  <div
    class="g-news-info new top-nav"
    id="news"
    v-if="extras.groupNewsDisplay.display == 1"
    :style="{
      background:
        extras.newsBg.colorOrBg == 'color'
          ? extras.newsBg.color
          : 'url(' + extras.newsBg.src + ')',
      'background-size': '100% 100%',
    }"
  >
    <div class="g-news-content u-w1200">
      <Title
        v-if="extras.newsTitle.display === 1"
        :title="extras.newsTitle.mainTitle || title"
        :en="extras.newsTitle.subTitle || 'News'"
        :extras="extras"
      />
      <div style="position: relative; overflow: hidden" ref="newsInfoTab">
        <div
          class="m-tab-list-new"
          v-if="
            columns.length > 1 || (columns.length == 1 && columns[0].id != 0)
          "
          :class="'tab-length' + columns.length"
          :style="{
            width: columns.length < 5 ? 'auto' : '',
            display: columns.length < 5 ? 'flex' : 'inline-block',
          }"
        >
          <div
            class="tab-new u-mr30"
            v-for="(item, index) in columns"
            :key="index"
            :class="{
              active: index == currentId,
              'cursor-default': isSetting == 1,
            }"
            @click="columnClick(item, index)"
          >
            {{ item.name }}
            <div data-v-2a8f24dd="" class="underline"></div>
          </div>
        </div>
      </div>
      <div
        class="g-news-list-new"
        :class="extras.newsStyle.style == '1' ? 'single-line' : ''"
        v-if="articles && articles.length > 0"
      >
        <div
          class="item"
          v-for="(item, i) in articles"
          :key="'b' + i"
          :style="{
            display: isShowMore == false && i > 3 ? 'none' : '',
            background:
              extras.newsItemBg.colorOrBg == 'color'
                ? extras.newsItemBg.color
                : 'url(' + extras.newsItemBg.src + ')',
          }"
        >
          <div class="date">
            <div
              class="day"
              v-if="extras.newsDay.display == 1"
              :style="{
                color:
                  extras.newsDay.text == 'custom'
                    ? extras.newsDay.fontColor
                    : '',
                'font-size':
                  extras.newsDay.text == 'custom'
                    ? extras.newsDay.fontSize + 'px'
                    : '',
                'font-style':
                  extras.newsDay.text == 'custom'
                    ? extras.newsDay.fontTilt == 'on'
                      ? 'italic'
                      : 'normal'
                    : '',
                'font-Weight':
                  extras.newsDay.text == 'custom'
                    ? extras.newsDay.fontWeight == 'on'
                      ? 'bolder'
                      : ''
                    : '',
              }"
            >
              {{ item.pushTime ? item.pushTime.substr(5, 5) : "" }}
            </div>
            <div
              class="year"
              v-if="extras.newsYear.display == 1"
              :style="{
                color:
                  extras.newsYear.text == 'custom'
                    ? extras.newsYear.fontColor
                    : '',
                'font-size':
                  extras.newsYear.text == 'custom'
                    ? extras.newsYear.fontSize + 'px'
                    : '',
                'font-style':
                  extras.newsYear.text == 'custom'
                    ? extras.newsYear.fontTilt == 'on'
                      ? 'italic'
                      : 'normal'
                    : '',
                'font-Weight':
                  extras.newsYear.text == 'custom'
                    ? extras.newsYear.fontWeight == 'on'
                      ? 'bolder'
                      : ''
                    : '',
              }"
            >
              {{ item.pushTime ? item.pushTime.substr(0, 4) : "" }}
            </div>
          </div>
          <div class="info">
            <a
              class="title"
              target="_blank"
              v-if="item.useLinkUrl == 1 && extras.newsTitleStyle.display == 1"
              :href="item.linkUrl"
              :style="{
                color:
                  extras.newsTitleStyle.text == 'custom'
                    ? extras.newsTitleStyle.fontColor
                    : '',
                'font-size':
                  extras.newsTitleStyle.text == 'custom'
                    ? extras.newsTitleStyle.fontSize + 'px'
                    : '',
                'font-style':
                  extras.newsTitleStyle.text == 'custom'
                    ? extras.newsTitleStyle.fontTilt == 'on'
                      ? 'italic'
                      : 'normal'
                    : '',
                'font-Weight':
                  extras.newsTitleStyle.text == 'custom'
                    ? extras.newsTitleStyle.fontWeight == 'on'
                      ? 'bolder'
                      : ''
                    : '',
              }"
              >{{ item.name }}</a
            >
            <a
              class="title"
              target="_blank"
              v-if="item.useLinkUrl != 1 && extras.newsTitleStyle.display == 1"
              :href="item.shortUrl"
              :style="{
                color:
                  extras.newsTitleStyle.text == 'custom'
                    ? extras.newsTitleStyle.fontColor
                    : '',
                'font-size':
                  extras.newsTitleStyle.text == 'custom'
                    ? extras.newsTitleStyle.fontSize + 'px'
                    : '',
                'font-style':
                  extras.newsTitleStyle.text == 'custom'
                    ? extras.newsTitleStyle.fontTilt == 'on'
                      ? 'italic'
                      : 'normal'
                    : '',
                'font-Weight':
                  extras.newsTitleStyle.text == 'custom'
                    ? extras.newsTitleStyle.fontWeight == 'on'
                      ? 'bolder'
                      : ''
                    : '',
              }"
              >{{ item.name }}</a
            >
            <div
              class="desc"
              v-if="extras.newsDesc.display == 1"
              :style="{
                color:
                  extras.newsDesc.text == 'custom'
                    ? extras.newsDesc.fontColor
                    : '',
                'font-size':
                  extras.newsDesc.text == 'custom'
                    ? extras.newsDesc.fontSize + 'px'
                    : '',
                'font-style':
                  extras.newsDesc.text == 'custom'
                    ? extras.newsDesc.fontTilt == 'on'
                      ? 'italic'
                      : 'normal'
                    : '',
                'font-Weight':
                  extras.newsDesc.text == 'custom'
                    ? extras.newsDesc.fontWeight == 'on'
                      ? 'bolder'
                      : ''
                    : '',
              }"
            >
              {{ item.desc }}
            </div>
          </div>
        </div>
        <div class="item1" v-for="(item, i) in articles" :key="i">
          <div
            class="info"
            :style="{
              background:
                extras.newsItemBg.colorOrBg == 'color'
                  ? extras.newsItemBg.color
                  : 'url(' + extras.newsItemBg.src + ')',
            }"
          >
            <img
              class="cover-img"
              :src="
                item.coverImageRealPath
                  ? item.coverImageRealPath
                  : require('@/assets/images/defaultNew.jpg')
              "
              alt=""
            />
            <div class="info-info">
              <a
                class="title"
                target="_blank"
                v-if="
                  item.useLinkUrl == 1 && extras.newsTitleStyle.display == 1
                "
                :href="item.linkUrl"
                :style="{
                  color:
                    extras.newsTitleStyle.text == 'custom'
                      ? extras.newsTitleStyle.fontColor
                      : '',
                  'font-size':
                    extras.newsTitleStyle.text == 'custom'
                      ? extras.newsTitleStyle.fontSize + 'px'
                      : '',
                  'font-style':
                    extras.newsTitleStyle.text == 'custom'
                      ? extras.newsTitleStyle.fontTilt == 'on'
                        ? 'italic'
                        : 'normal'
                      : '',
                  'font-Weight':
                    extras.newsTitleStyle.text == 'custom'
                      ? extras.newsTitleStyle.fontWeight == 'on'
                        ? 'bolder'
                        : ''
                      : '',
                }"
                >{{ item.name }}</a
              >
              <a
                class="title"
                target="_blank"
                v-if="item.useLinkUrl != 1"
                :href="item.shortUrl"
                :style="{
                  color:
                    extras.newsTitleStyle.text == 'custom'
                      ? extras.newsTitleStyle.fontColor
                      : '',
                  'font-size':
                    extras.newsTitleStyle.text == 'custom'
                      ? extras.newsTitleStyle.fontSize + 'px'
                      : '',
                  'font-style':
                    extras.newsTitleStyle.text == 'custom'
                      ? extras.newsTitleStyle.fontTilt == 'on'
                        ? 'italic'
                        : 'normal'
                      : '',
                  'font-Weight':
                    extras.newsTitleStyle.text == 'custom'
                      ? extras.newsTitleStyle.fontWeight == 'on'
                        ? 'bolder'
                        : ''
                      : '',
                }"
                >{{ item.name }}</a
              >
              <div class="underline"></div>
              <div
                class="desc"
                v-if="extras.newsDesc.display == 1"
                :style="{
                  color:
                    extras.newsDesc.text == 'custom'
                      ? extras.newsDesc.fontColor
                      : '',
                  'font-size':
                    extras.newsDesc.text == 'custom'
                      ? extras.newsDesc.fontSize + 'px'
                      : '',
                  'font-style':
                    extras.newsDesc.text == 'custom'
                      ? extras.newsDesc.fontTilt == 'on'
                        ? 'italic'
                        : 'normal'
                      : '',
                  'font-Weight':
                    extras.newsDesc.text == 'custom'
                      ? extras.newsDesc.fontWeight == 'on'
                        ? 'bolder'
                        : ''
                      : '',
                }"
              >
                {{ item.desc }}
              </div>
              <div class="date">
                <div
                  class="day"
                  v-if="extras.newsDay.display == 1"
                  :style="{
                    color:
                      extras.newsDay.text == 'custom'
                        ? extras.newsDay.fontColor
                        : '',
                    'font-size':
                      extras.newsDay.text == 'custom'
                        ? extras.newsDay.fontSize + 'px'
                        : '',
                    'font-style':
                      extras.newsDay.text == 'custom'
                        ? extras.newsDay.fontTilt == 'on'
                          ? 'italic'
                          : 'normal'
                        : '',
                    'font-Weight':
                      extras.newsDay.text == 'custom'
                        ? extras.newsDay.fontWeight == 'on'
                          ? 'bolder'
                          : ''
                        : '',
                  }"
                >
                  {{
                    item.pushTime
                      ? item.pushTime.substr(5, 5)
                      : item.createTime
                      ? item.createTime.substr(5, 5)
                      : ""
                  }}
                </div>
                <div
                  class="year"
                  v-if="extras.newsYear.display == 1"
                  :style="{
                    color:
                      extras.newsYear.text == 'custom'
                        ? extras.newsYear.fontColor
                        : '',
                    'font-size':
                      extras.newsYear.text == 'custom'
                        ? extras.newsYear.fontSize + 'px'
                        : '',
                    'font-style':
                      extras.newsYear.text == 'custom'
                        ? extras.newsYear.fontTilt == 'on'
                          ? 'italic'
                          : 'normal'
                        : '',
                    'font-Weight':
                      extras.newsYear.text == 'custom'
                        ? extras.newsYear.fontWeight == 'on'
                          ? 'bolder'
                          : ''
                        : '',
                  }"
                >
                  {{ item.pushTime ? item.pushTime.substr(0, 4) : "" }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="m-nodata-body" v-if="articles && articles.length == 0">
        <img src="@/assets/images/nodata.png" />
        <div class="m-nodata">暂无数据</div>
      </div>
    </div>
  </div>
</template>

<script>
import Title from "./Title.vue";
import { URLS } from "fire-wind-water";
import IScroll from "iscroll";

export default {
  components: {
    Title,
  },
  props: {
    newsInfo: Object,
    extras: Object,
  },
  data() {
    return {
      title: "新闻资讯",
      currentId: 0,
      columns: [],
      isSetting: 0,
      articles: [],
      moreClass: "max",
      isShowMore: false,
    };
  },
  created() {
    if (URLS.getURL("isSetting") == 1) {
      this.isSetting = 1;
    }
  },
  mounted() {
    //this.initColumns();
    let tempColumns = this.getColumns.articleInitColumns(
      this.newsInfo.column,
      this.newsInfo.article,
      "热门资讯",
      true
    );
    this.columns = tempColumns;
    if (this.columns.length > 1) {
      this.$nextTick(() => {
        new IScroll(this.$refs.newsInfoTab, {
          mouseWheel: false, // 鼠标滚轮控制
          scrollbars: false, //滚动条的显示
          scrollX: true,
          scrollY: false,
        });
      });
    }
    this.articles = this.columns.length > 0 ? this.columns[0].article : [];
    //    this.currentId = this.columns[0].id;
  },
  methods: {
    columnClick(item, idx) {
      if (URLS.getURL("isSetting") == 1) {
        return;
      }
      this.currentId = idx;
      this.articles = item.article;
    },
    showMoreArticle() {
      if (URLS.getURL("isSetting") == 1) {
        return;
      }
      this.isShowMore = !this.isShowMore;
    },
  },
};
</script>
<style scoped></style>
